export enum PartnerType {
    user = "user",
    danceSchool = "dance-school"
}